import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-securitycheck',
  templateUrl: './securitycheck.component.html',
  styleUrls: ['./securitycheck.component.css']
})
export class SecuritycheckComponent implements OnInit {

  public matFormSize = '12px';
  public filterForm: FormGroup;
  public maxDate = new Date();
  public maxEndDate = new Date();
  date = new Date();
  public formSubmitted: boolean = false;
  public _activeMenu: string = 'Security Check';
  public attendanceData = [];

  // Modal variables
  public previewPopup: boolean = true;
  public securityFormClose: boolean = true;
  public previewModalTitle: string = 'Security Check'
  public modalData: any = {}
  // {
  //   "attendanceID": "63da96e97ede5c9143c2c9cf",
  //   "orgID": "626d347f61dd2331e3c07b4f",
  //   "routeID": "63da91abb02ea12f1afad6a3",
  //   "tripDate": 1675189800000.0,
  //   "vehRegNo": "TN51AB7070",
  //   "atndType": "escort",
  //   "attenData": [
  //     {
  //       "empRefID": "OP5-063",
  //       "empName": "vivek",
  //       "empID": "6332f0f0b670cb347a926d24",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "ABC124",
  //       "empName": "h",
  //       "empID": "6345312a2e9acf5d43c30788",
  //       "isBoarded": true,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "123",
  //       "empName": "shewag",
  //       "empID": "638596c88d44f1f6cf9d5b6a",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "TC4-200",
  //       "empName": "Vignesh kumar",
  //       "empID": "626fa75ceeede859ea1fdff8",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "ABC-2022",
  //       "empName": "Seetha Lakshmi",
  //       "empID": "62da9d5d35b9b13239f23875",
  //       "isBoarded": true,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "ABC005",
  //       "empName": "vasudevan vasudevan vasudevan vasudevan vasudevan vasudevan",
  //       "empID": "62da4df835b9b13239f2381b",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "TC4-205",
  //       "empName": "Ragu",
  //       "empID": "62da4df535b9b13239f2381a",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "TC4-199",
  //       "empName": "ragu",
  //       "empID": "63da5e4eb02ea12f1afad66d",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "456",
  //       "empName": "Kanthan",
  //       "empID": "63d92ecf9ac92f1b86f5f9e0",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "TC4-220",
  //       "empName": "vasanthi",
  //       "empID": "62e505dccc8d1eebdb3125cb",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     },
  //     {
  //       "empRefID": "TEST568",
  //       "empName": "Surya A",
  //       "empID": "63298d767f0b7e3f015fdb25",
  //       "isBoarded": false,
  //       "attendanceID": "63da96e97ede5c9143c2c9cf"
  //     }
  //   ],
  //   "createdAt": 1675271390145.0,
  //   "routeName": "refresh",
  //   "scanTime": 1675271388425.0,
  //   "status": 1,
  //   "transitMode": "Drop",
  //   "vehLoc": {
  //     "lat": "12.9627226",
  //     "lng": "80.1961924"
  //   }
  // }


  /* Pagination */
  pageNum = 1;
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  /* filters */
  public filterData = {};
  searchChangeObserver: any;
  public searchInputValue = '';

  public errorObject: any = {};

  public showTable: boolean = true;
  public tableData: any = [];
  public cols: any = [];
  public vehicleCols:any = [
    { key: '#', display: '#' },
    // { key: 'empName', display: 'Employee Name' },
    // { key: 'empRefID', display: 'Employee ID', config:{ isUppercase:true } },
    {
      key: 'vehRegNo', display: 'Reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'routeName', display: 'Route name' ,headerConfig:{ isDefault: true}},
    { key: 'transitMode', display: 'Transit mode',headerConfig:{ isDefault: true} },
    {
      key: 'scanTime', display: 'Date & Time', config: {
        isDate: true,
        format: 'dd/MM/YYYY HH:mm:ss'
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'view', color: 'primary', icon: 'View' },
          { display: 'Excel download', color: 'tablebtnSuccess', icon: 'ExcelDocument' },
          // { display: 'Delete', color: 'warn', icon: 'Delete' },
          // { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' }
        ]
      }
    }

  ];
  public employeeCols:any = [
    { key: '#', display: '#' },
    { key: 'empName', display: 'Employee name',
      config: {
        isTruncate: true,

        truncateData: {
          limit: 20,
          concatVal: '...',
        }
    } ,
    headerConfig:{ isDefault: true}
    },
    { key: 'empRefID', display: 'Employee id', config:{ isUppercase:true,
      isBadge:true,
      badgeData:[{
        key:'isManual',name:'NB',badgeClass:"badge-primary",title:'Not booked'
      }], } ,
      headerConfig:{ isDefault: true}},
    {
      key: 'vehRegNo', display: 'Vehicle reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'routeName', display: 'Route name',
    headerConfig:{ isDefault: true} },
    { key: 'transitMode', display: 'Transit mode',
    headerConfig:{ isDefault: true} },
    {
      key: 'scanTime', display: 'Date & Time', config: {
        isDate: true,
        format: 'dd/MM/YYYY HH:mm:ss'
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'isBoarded', display: 'Boarded status', config: { isYesOrNo: true,
      title:{
        yesTitle:'Boarded',
        noTitle:'Not Boarded'
      }
    },
    headerConfig:{ isDefault: true}
    }

  ];
  public noDataFoundEnable: boolean = false;
  /* Excel */
  public attendanceExcelData: any = [];
  public filterObj:any='';
  public excelData = {};
  public showDownloadBtn: boolean = false;
  public isSecurity: boolean = false;
  public attendanceType: any = ['escort','security']
  public currentDate:boolean=true;
  /* Employee view */
  public isEmpTable:boolean = false;
  public bookedSts:boolean=false;
  public bookValues:any=[{
      key:'Not Booked',
      value:'notBooked'
    },{
      key:'Booked',
      value:'Booked',
    },
  ]
  constructor(
    private api: ApiService,
    private storage: StorageService,
    private fb: FormBuilder,
    private com: CommonServices,
    private excel: ExcelExportService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.cols = this.vehicleCols;
  }

  ngOnInit(): void {
    this.filterFormLoad();
    this.getAttendanceReport(1,10,{ startDate: new Date(new Date().setHours(0,0,0,0)).getTime(), endDate:new Date(new Date().setHours(23,59,59,999)).getTime()});
  }

  onActionHandler(e: any) {
    if (e && e.action.display == 'view') {
      this.modalData = e.data;
      this.securityFormClose = false
    }
    else if (e && e.action.display == 'Excel Download') {
      if (e && e.data && e.data.attenData) {
        this.saveToExcel(e.data);
      }
    }
  }

  getDropDownVal(e:any){
    if( this.filterForm.value.viewType=='employee'){
      this.bookedSts=true;
      this.filterForm.controls.isManual.patchValue('');
    }else if(this.filterForm.value.viewType=='vehicle'){
      this.bookedSts=false;
      this.showDownloadBtn=false;
    }
  }

  getAttendanceReport(page: number = 1, limit = 10, filter = null,) {
    let obj = { page, limit, atndType: this.attendanceType };
    if (filter) {
      obj = {
        ...obj,
        ...filter,
      };
      this.filterData = { ...filter };
    }
    this.api.transportManagerEmpAttendanceReport(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          if(obj['viewType']) this.changeTableView(obj['viewType']); 
          this.attendanceData = res['data'];
          this.tableData = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        this.processPagination(res, obj);
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('err', err);
    })
    if(this.attendanceData.length>0)  this.currentDate=false

  }

  getAttendanceExlReport(obj) {
    this.attendanceExcelData = [];
    obj['atndType'] = this.attendanceType;
    this.api.transportManagerEmpAttendanceExlReport(obj).then(async (res: any) => {

      if (res && res.data && res.data.length > 0) {
        this.attendanceExcelData = res.data;
      }
    }).catch((err) => { console.log(err) })
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getAttendanceReport(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getAttendanceReport(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  changeTableView(value:any){
    if(value=='employee'){
      this.showPagination = false;
      this.isEmpTable = true;
      this.cols = this.employeeCols;
    }else{
      this.showPagination = true;
      this.isEmpTable = false;
      this.cols = this.vehicleCols;
    }
  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getAttendanceReport(data.page, data.limit, filterObj);
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({
       // vehRegNo: new FormControl(''),
      // routeName: new FormControl(''),
      // empName: new FormControl(''),
      search:new FormControl(''),
      isManual:new FormControl(''),
      startDate: new FormControl(new Date(new Date().setHours(0,0,0,0)), [Validators.required]),
      endDate: new FormControl(new Date(new Date().setHours(23,59,59,999)), [Validators.required]),
      viewType: new FormControl('vehicle',[Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
    }
    else {
      this.maxEndDate = new Date();
    }
    this.checkValidation();
  }

  validation(data) {
    if (this.errorObject['invalidDate']) delete this.errorObject['invalidDate'];
    let objectKeys = Object.keys(data);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        let setDate = new Date(new Date(data.startDate).setDate(new Date(data.startDate).getDate() + 30)).getTime();
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid End date';
        }
        else if (new Date(data.endDate).getTime() > setDate) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid End date';
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    this.formSubmitted = true;
    this.showDownloadBtn = false;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      // if (this.filterForm.value.vehRegNo != '') obj['vehRegNo'] = this.filterForm.value.vehRegNo;
      // if (this.filterForm.value.empName != '') obj['empName'] = this.filterForm.value.empName;
      // if (this.filterForm.value.routeName != '') obj['routeName'] = this.filterForm.value.routeName;
      if(this.filterForm.value.search!='') obj['search'] = this.filterForm.value.search;
      if (this.filterForm.value.viewType != '') obj['viewType'] = this.filterForm.value.viewType;

        if(this.filterForm.value.viewType == 'employee'){
          if( this.filterForm.value.isManual!=''){
            obj['isManual'] = 
            (this.filterForm.value.isManual!='' && this.filterForm.value.isManual=='notBooked') ? true 
            : (this.filterForm.value.isManual!='' && this.filterForm.value.isManual=='Booked') ? false:'';
            this.filterObj=obj
          }
        }else{
          this.filterForm.controls.isManual.patchValue('');
          }

      this.showDownloadBtn = true;
      this.getAttendanceReport(this.paginationData.page, this.paginationData.limit, obj);
      this.getAttendanceExlReport(obj);
    }
  }

  async exportToExcel() {
    let data = [];

    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));
    for (let i = 0; i < this.attendanceExcelData.length; i++) {
      let item = this.attendanceExcelData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
            item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
            item.routeName ? this.com.convertTitleCase(item.routeName) : '---',
            item.scanTime ? this.com.timestampToDate(item.scanTime, 'DMY H:M:S') : '---',
            item.isBoarded ? 'Boarded' : 'Not Boarded',
            item.isManual ? 'Not Booked' : 'Booked',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'I';
      let customizedData = [];
      let titleRow = {
        value: ['Security Check Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },

        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      rowCount += 3;

      let subtitleRow = {
        
        value: this.filterObj["isManual"] ? [ 
          "Title :" +'Not Booked Employees Report' + "\n" +
          "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
        ]:
        [ 
          "Title :" +'Booked Employees Report' + "\n" +
          "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
        ] ,
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 2) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Employee name', 'Employee ID', 'Reg no', 'Transit mode', 'Route name','Date & Time','Boarding status','Booking status'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);

      if (this.excelData['Security_Check_Report'] == undefined) { this.excelData['Security_Check_Report'] = {}; }

      this.excelData['Security_Check_Report'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 25 }, { colNo: 6, width: 25 },{ colNo: 7, width: 25 }, { colNo: 8, width: 25 }, { colNo: 9, width: 35 }]
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Security_Check_Report_' + new Date().getTime() + '.xlsx');
  }

  saveToExcel(reportData: any) {
    let data = [];

    for (let i = 0; i < reportData.attenData.length; i++) {
      let item = reportData.attenData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.empName ? this.com.convertTitleCase(item.empName) : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.isBoarded ? 'Boarded' : 'Not Boarded',
            item.isManual ? 'Not Booked' : 'Booked',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }

    if (data.length > 0) {

      let rowCount = 2;
      let endCell = 'E';
      let customizedData = [];

      let titleRow = {
        value: ['Security Check Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },

        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);
      rowCount += 4;
      let subtitleRow = {
        value: [
          "Route Name     : " + reportData.routeName + "\n" +
          "Vehicle Reg No :" + reportData.vehRegNo + "\n" +
          "Transit Mode    : " + reportData.transitMode + "\n" +
          "Date                 : " + this.com.timestampToDate(new Date(reportData.scanTime).getTime(), 'DMY H:M:S')
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 3) + ''}:${endCell + rowCount + ''}`,
      }
      customizedData.push(subtitleRow);

      rowCount += 2;
      let headerRow =
      {
        value: ['S.No.', 'Employee Name', 'Employee ID', 'Boarded Status','Booking Status'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);

      if (this.excelData['Security_Check_Report'] == undefined) { this.excelData['Security_Check_Report'] = {}; }

      this.excelData['Security_Check_Report'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 20 }, { colNo: 4, width: 30 },{ colNo: 5, width: 30 }]
        }
      };// excelInfo;
      this.downloadExlReport();
    }
  }

  allExcelDownload(){
    
    let rowCount=2;
    let customizedData=[];
    let endCell = 'E';

    let titleRow = {
      value: ['Security Check Report'],
      font: {
        name: 'Corbel', family: 4, size: 16, bold: true,
        color: { argb: 'FFFFFFFF' },

      },
      mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      alignment: {
        cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
      },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '966462AF' },
        bgColor: { argb: '966462AF' }
      },
    }
    customizedData.push(titleRow);
    
    for(let i=0;i<this.attendanceExcelData.length;i++){
      let singleVeh=this.attendanceExcelData[i]

      rowCount += 4;
      let subtitleRow = {
        value: [
          "Route Name     : " + this.com.convertTitleCase(singleVeh.routeName) + "\n" +
          "Vehicle Reg No :" + String(singleVeh.vehRegNo).toUpperCase() + "\n" +
          "Transit Mode    : " + singleVeh.transitMode + "\n" +
          "Date                 : " + this.com.timestampToDate(new Date(singleVeh.scanTime).getTime(), 'DMY H:M:S')
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 3) + ''}:${endCell + rowCount + ''}`,
      }
      customizedData.push(subtitleRow);
     

     if(singleVeh['attenData'] && singleVeh['attenData'].length>0){
      
      rowCount +=1 
      let empTabHeaders =
      {
        value: ['S No', 'Employee name', 'Employee ID', 'Boarded status','Booking status'],
       
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(empTabHeaders);
    

        for(let j=0;j<singleVeh['attenData'].length;j++){
          rowCount +=1 
          let singleEmp=singleVeh['attenData'][j]
          let res = {
            value: [
              j + 1,
              singleEmp.empName ? this.com.convertTitleCase(singleEmp.empName) : '---',
              singleEmp.empRefID ? String(singleEmp.empRefID).toUpperCase() : '---',
              singleEmp.isBoarded ? 'Boarded' : 'Not Boarded',
              singleEmp.isManual ? 'Not Booked' : 'Booked',
            ],
          }
          customizedData.push(res);
        }  
        rowCount +=1;
        let vehDivder = {
          value: [],
          mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`
        }
        customizedData.push(vehDivder);
    }
  }
  if (this.excelData['Security_Check_Report'] == undefined) { this.excelData['Security_Check_Report'] = {}; }

  this.excelData['Security_Check_Report'] = {
    customizedData: customizedData,
    data: {
      columWith: [{ colNo: 2, width: 30 }, { colNo: 3, width: 20 }, { colNo: 4, width: 30 },{ colNo: 5, width: 30 }]
    }
  };// excelInfo;
  this.downloadExlReport();
  }


}
